import {useState, useEffect, useRef} from 'react'
import {UserSelect, User,FetchActiveUsers} from './UserSelect'
import AdminNavBar from './AdminNavBar'
import ReportNavBar from './ReportNavBar'
import UserReportTotal from './UserReport'
import { SelectInstance } from 'react-select'

const Report = () => {
	interface Option {
		value: any;
		label: string;
	}

	var userRef = useRef<HTMLSelectElement>(null)
	var startDateRef = useRef<HTMLInputElement>(null)
	var endDateRef = useRef<HTMLInputElement>(null)
	var selectRef = useRef<SelectInstance<Option | null>>(null)
	const [isUserSet, setIsUserSet] = useState(false)
	const [isStartDateSet, setStartDateSet] = useState(false)
	const [isEndDateSet, setEndDateSet] = useState(false)	
	const [users, setUsers] = useState<User[]>([])
	const [selectedUser, setSelectedUser] = useState<User>({id:0, first_name:"", middle_name: "", last_name:"", signed_in:false, photo:"", active: false, email:"", password:"", role:""})
	const [key, setKey] = useState("")
	useEffect(() => {
		FetchActiveUsers(setUsers)
	}, [])

	function CheckStartDateSet(): boolean {
		if (startDateRef && startDateRef.current && startDateRef.current.value !== "") {
			return true;
		} else {
			return false;
		}
	}

	function CheckEndDateSet(): boolean {
		if (endDateRef && endDateRef.current && endDateRef.current.value !== "") {
			return true;
		} else {
			return false;
		}
	}

	const clearEntries = () => {
		setStartDateSet(false)
		setEndDateSet(false)
		if (startDateRef && startDateRef.current) {
			startDateRef.current.value = ""
		}
		if (endDateRef && endDateRef.current) {
			endDateRef.current.value = ""
		}
	}

	const EndDateChange = () => {
		if (CheckEndDateSet()) {
			setEndDateSet(true)
		} else {
			setEndDateSet(false)
		}
		if(startDateRef.current && endDateRef.current) {
			setKey(startDateRef.current?.value + endDateRef.current?.value)
		}
	}

	const StartDateChange = () => {
		if (CheckStartDateSet()) {
			setStartDateSet(true)
		}
		else {
			setStartDateSet(false)
		}
		if(startDateRef.current && endDateRef.current) {
			setKey(startDateRef.current?.value + endDateRef.current?.value)
		}
	}
	
	return (
		<div className="resilire">
			<AdminNavBar />
			<ReportNavBar />
			<label>Timesheet</label>
			<UserSelect isVisible={isUserSet}  setIsVisible={setIsUserSet} users={users} setUsers={setUsers} setSelectedUser={setSelectedUser} ref={userRef} onChange={clearEntries } selectRef={selectRef} />
			<label htmlFor="start_date">Start Date</label>
			<input type="date" id="start_date" name="start_date" ref={startDateRef} onChange={() => StartDateChange()} />
			<label htmlFor="end_date">End Date</label>
			<input type="date" id="end_date" name="end_date" ref={endDateRef} onChange={() => EndDateChange()} />
			{
				isUserSet && isStartDateSet && isEndDateSet && <UserReportTotal key={key} id={selectedUser.id} startDateRef={startDateRef} endDateRef={endDateRef} />
			}
			{
				isUserSet && (!isStartDateSet || !isEndDateSet) &&  selectedUser.signed_in === true && <p> User is signed in. This may cause the timesheet to be inaccurate </p>
			}
		</div>
	)
};

export default Report;
